// Configure your import map in config/importmap.rb. Read more: https://github.com/rails/importmap-rails
import { createApp } from 'vue/dist/vue.esm-bundler';
import App from '../App.vue'

const app = createApp(App)

app.mount('#app');
